enum SessionState {
  FAILED = 'FAILED',
  LOADING = 'LOADING',
  NONE = 'NONE',
  SUCCESS = 'SUCCESS'
}

export default SessionState;
